
<div class="backgroundDialog" style="width: 100%;  height: 100%; padding: 0px;margin: auto; border: 5px solid rgb(207, 121, 1);">

  <div style="width: 100%; height: 100%; ">

    <div style="text-align: center; width: 5%;display: inline-block;  " >
      <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                        background-color: rgb(46, 163, 80); font-size: 20px;">
          &nbsp;&nbsp;Observação
      </mat-card>
    </div>
    <div style="text-align: right; width: 93%; display: inline-block; " >
      <button  (click)="onNoClick()">
        <img src="../../assets/img/icones/fecharJanela.png" width="100%">
    </button>
    </div>




    <form [formGroup]="formObs" novalidate>

      <!--Definir o tamanho da tela-->
      <div style=" width: 100%; overflow:hidden; text-align: center; border-top: 5px solid rgb(207, 121, 1);
                  background-color: rgb(51, 68, 75); text-align: center;">

          <div style="width: 100%; height: 235px; overflow-y: auto; overflow-x: hidden;">

              <table style="width: 98%; margin: 10px;   ">

                <tr>

                  <td style="width: 100%;">


                        <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px;
                                background-color:rgb(207, 121, 1);" class="mat-elevation-z4">

                          <table style="text-align: left; width: 100%; height: 98%;">

                                <tr style="cursor: pointer;">
                                  <td style="width: 100%; height: 100%;" >

                                    <mat-card class="mat-elevation-z5" style="font-size: 12px; height: 100%;  padding: 8px;
                                                                              background-color:rgb(252, 247, 242) ">


                                     

                                      <table style="width: 100%; margin-top: 5px;">
                                        <tr>
                                          <td style="width: 100%;">
                                            {{formObs.value.pergDsObservacao}}
                                          </td>

                                      </table>


                                    </mat-card>
                                  </td>
                              </tr>

                            </table>

                        </mat-card>

                      </td>
                </tr>

              </table>
        </div>

      </div>

    </form>

  </div>

</div>
